import React from 'react'

export const NavbarEmpty: React.FC = () => {
  return (
    <div className='navbar-empty'>No chats found.</div>
  )
};